import { render, staticRenderFns } from "./cardCedisLocal.vue?vue&type=template&id=2d64b4b0&scoped=true&"
import script from "./cardCedisLocal.vue?vue&type=script&lang=js&"
export * from "./cardCedisLocal.vue?vue&type=script&lang=js&"
import style0 from "./cardCedisLocal.vue?vue&type=style&index=0&id=2d64b4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64b4b0",
  null
  
)

export default component.exports